
<div class="row">
  <div class="card">
    <div class="card-body bg-white">
  <form  (ngSubmit)="onSubmit(passportCheck.value,'form')" [formGroup]="passportCheck">
<div class="card pt-0 mb-5">
    <div class="card-header">
        <h4>Passport Check</h4>
      </div>
    <div class="card-body">
   <div class="row mb-2">
    <div class="col-lg-6 col-md-6">
        <label class="d-flex align-items-center fs-6 fw-semibold">
            <span class="">Name on Passport</span>
        </label> 
        <input type="text" class="form-control form-control-solid" formControlName="name" id="name" > 
       <div  class="invalid-feedback"> </div>
    </div>
    <div class="col-lg-6 col-md-6">
        <label class="d-flex align-items-center fs-6 fw-semibold">
            <span class="">Passport Number</span>
        </label>
        <input type="text" class="form-control form-control-solid" formControlName="passportNumber" id="passportNumber"  [ngClass]="{'is-invalid': isForm2Submitted && passportCheck.controls.passportNumber.errors}" > 
        <div  class="invalid-feedback" *ngIf="isForm2Submitted && passportCheck.controls.passportNumber.errors?.required"> Please enter passport number.</div>
    </div>
   </div>
   <div class="row">
    <div class="col-lg-6 col-md-6">
        <label class="d-flex align-items-center fs-6 fw-semibold">
            <span class="">D.O.B</span>
        </label>
        <input type="date" class="form-control form-control-solid" formControlName="dob" id="dob" [ngClass]="{'is-invalid': isForm2Submitted && passportCheck.controls.passportNumber.errors}"> 
        <div  class="invalid-feedback" *ngIf="isForm2Submitted && passportCheck.controls.dob.errors?.required">  Please enter passport DOB.</div>
    </div>
    <div class="col-lg-6 col-md-6">
        <div class="form-check d-inline-block mt-5">
            <label class="form-check-label  mr-4">
              <input type="radio" class="form-check-input"formControlName="origin" id="isInIndia" value="IN">With-in India
            </label>
          </div>
          <div class="form-check d-inline-block mt-5">
            <label class="form-check-label  ml-2">
              <input type="radio" class="form-check-input" formControlName="origin" id="isInIndia1" value="OIN" >Outside India
            </label>
          </div>         
    </div>
   </div>
   <div class="row">
    <div class="col-sm-2">
        <br>
        <div class="mb-3">
        <button class="btn  btn-primary"
              type="submit" value="Submit">Search</button>
      </div>
      </div>
   </div>
    </div>
    </div>
  </form>

  <div class="card pt-0 mb-5">
    <div class="row" style="min-height: 300px">
        <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine">         
          <ag-grid-angular
          style="width: 100%; height: 350px;"
          class="ag-theme-alpine"
          [columnDefs]="columnDefs"
          [defaultColDef]="defaultColDef"
          [suppressRowClickSelection]="true"
          [groupSelectsChildren]="true"
          [rowSelection]="'multiple'"
          [columnDefs]="tableSelectedColumn"
          [pagination]="true"
          [paginationPageSize]=10
          [rowData]="rowData"
        ></ag-grid-angular>         
        </div>
      </div>      
</div>
</div>
</div>
</div>
